export default "__VITE_ASSET__1840a051__"